var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"scroller"},[_c('div',{staticClass:"bg",style:({background:  _vm.color}),on:{"click":_vm.close}}),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }